import { Component, Renderer2, Inject, ViewChild, signal } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { F2aService } from '../../../core/service/2fa/fa.service';
import { LocalStorageService } from '../../../core/service/localStorage/local-storage.service';
import { parseOtpAuth } from '../../../core/helpers/globalHelperfunc';
import jsQR from 'jsqr';
import { PopupServiceService } from '../../../core/service/popup/popup-service.service';
import { Output, EventEmitter } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { permissionEntity } from '../../../core/constants/permission';
import { PermissionsPipe } from '../../../core/pipe/permissions.pipe';
import { MatSelect } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { createPaginatedState, PaginatedState, SearchBinding } from '../../../core/constants/filter-types';
import { AgentService } from '../../../core/service/all-agent/all-agent.service';
import { forkJoin, map, Subject } from 'rxjs';
import { fetchPaginatedData, handlePaginatedResponse, registerSearchHandlers } from '../../../core/helpers/search-helper';

@Component({
  selector: 'app-custom-component',
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    MatProgressBarModule,
    PermissionsPipe 
  ],
  templateUrl: './custom-component.component.html',
  styleUrl: './custom-component.component.scss'
})
export class CustomComponentComponent {
  @Output() dialogOpened = new EventEmitter<boolean>();
  permissions_entity = permissionEntity;
  private overlay!: HTMLElement;
  private selectionBox!: HTMLElement;
  private startX = 0;
  private startY = 0;
  private isDragging = false; // track drag state
  private timerInterval: any;
  qrCode:any
  showQrCode:boolean = true;
  editItem:boolean = false
  manualQrCode:boolean = false;
  qrImage:boolean = false;
  otpUrls:boolean = false;
  upload_files: any = [];
  issueValue:string = '';
  labelValue:string = '';
  secretValue:string = '';
  url:string = '';
  userId: any;
  private readonly TOTP_DURATION = 30;
  copiedIndex: number | null = null;

  activeUserDropdownIndex: number | null = null;

  @ViewChild('selectMarketingManager') selectMarketingManager!: MatSelect;
  isMarketingManagerOpen: boolean = false;
  marketingMangerMultiSelectControl = new FormControl<string[]>([]);
  selctedMarketingManagerArray = signal<string[]>([]);
  selectedMarketingMangerMap = new Map<string, string>();
  marketingMangerCompanySearchCtrl = new FormControl('');
  marketingManagerState: PaginatedState<any> = createPaginatedState();
  limit = 50
  private destroy$ = new Subject<void>();
  private readonly PIXEL_TOLERANCE = 3.0;
  private isLoadingMoreMap = new Map<string, boolean>();

  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private authenticatorService: F2aService,
    public localStorageService:LocalStorageService,
    public _popup: PopupServiceService,
    public agentService :AgentService,
  ) {}
  async ngOnInit() {
    const currentUser = await this.localStorageService.getKeyIndexedDbKey('currentUser');
    this.userId = currentUser?.id || '';
    // ✅ Don't fetch here — wait for menu open event
    this.dialogOpened.emit(true);
    const bindings: SearchBinding<any>[] = [
        {
          control: this.marketingMangerCompanySearchCtrl,
          state: this.marketingManagerState,
          fetchFn: () => this.getAllMarketManagers(),
          isOpen: () => this.isMarketingManagerOpen,
        }
      ];
  
      registerSearchHandlers(bindings, this.destroy$);
    
  }
  enableSelection() {
    // Create overlay attached to body
    this.overlay = this.renderer.createElement('div');
    this.renderer.setStyle(this.overlay, 'position', 'fixed');
    this.renderer.setStyle(this.overlay, 'top', '0');
    this.renderer.setStyle(this.overlay, 'left', '0');
    this.renderer.setStyle(this.overlay, 'width', '100vw');
    this.renderer.setStyle(this.overlay, 'height', '100vh');
    this.renderer.setStyle(this.overlay, 'background', 'rgba(0,0,0,0.6)');
    this.renderer.setStyle(this.overlay, 'cursor', 'crosshair');
    this.renderer.setStyle(this.overlay, 'z-index', '999999');
    this.renderer.appendChild(this.document.body, this.overlay);
    // Create selection rectangle but hide it initially
    this.selectionBox = this.renderer.createElement('div');
    this.renderer.setStyle(this.selectionBox, 'position', 'absolute');
    this.renderer.setStyle(this.selectionBox, 'border', '2px dashed white');
    this.renderer.setStyle(this.selectionBox, 'background', 'rgba(255,255,255,0.2)');
    this.renderer.setStyle(this.selectionBox, 'display', 'none'); // hidden initially
    this.renderer.appendChild(this.overlay, this.selectionBox);
    // Attach mouse event listeners
    this.overlay.addEventListener('mousedown', this.onMouseDown);
    this.overlay.addEventListener('mousemove', this.onMouseMove);
    this.overlay.addEventListener('mouseup', this.onMouseUp);
  }
  private onMouseDown = (event: MouseEvent) => {
    this.isDragging = true;
    this.startX = event.clientX;
    this.startY = event.clientY;
    // Show selection box at starting point with zero size
    this.renderer.setStyle(this.selectionBox, 'left', `${this.startX}px`);
    this.renderer.setStyle(this.selectionBox, 'top', `${this.startY}px`);
    this.renderer.setStyle(this.selectionBox, 'width', `0px`);
    this.renderer.setStyle(this.selectionBox, 'height', `0px`);
    this.renderer.setStyle(this.selectionBox, 'display', 'block');
  };
  private onMouseMove = (event: MouseEvent) => {
    if (!this.isDragging) return; // only resize if dragging
    const currentX = event.clientX;
    const currentY = event.clientY;
    const width = Math.abs(currentX - this.startX);
    const height = Math.abs(currentY - this.startY);
    const left = Math.min(this.startX, currentX);
    const top = Math.min(this.startY, currentY);
    this.renderer.setStyle(this.selectionBox, 'left', `${left}px`);
    this.renderer.setStyle(this.selectionBox, 'top', `${top}px`);
    this.renderer.setStyle(this.selectionBox, 'width', `${width}px`);
    this.renderer.setStyle(this.selectionBox, 'height', `${height}px`);
  };
  private onMouseUp = () => {
    if (!this.isDragging) return;
    this.isDragging = false;
    // Hide and remove overlay and selection box after mouse up
    this.renderer.removeChild(this.document.body, this.overlay);
    // Remove event listeners to avoid leaks
    this.overlay.removeEventListener('mousedown', this.onMouseDown);
    this.overlay.removeEventListener('mousemove', this.onMouseMove);
    this.overlay.removeEventListener('mouseup', this.onMouseUp);
  };
 getUserWise2FA(userId: string) {
    this.authenticatorService.getUserWise2FA(userId).subscribe({
      next: (res) => {
        const data = res?.data;
        const prevCodes: Record<string, string> = {};

        // ── Store previous codes before overwriting ──
        if (this.qrCode) {
          this.qrCode.forEach((item: any) => {
            prevCodes[item.issuer] = item.code;
          });
        }

        this.qrCode = data;

        this.qrCode.forEach((item: any) => {
          item.radius = 10;
          item.circumference = 2 * Math.PI * item.radius;
          item.offset = item.circumference * (1 - (item.expiresIn / this.TOTP_DURATION));

          // ── Only animate if the code actually changed ──
          const codeChanged = prevCodes[item.issuer] !== undefined
            ? prevCodes[item.issuer] !== item.code
            : true; // first load → animate

          if (codeChanged) {
            item.updated = false;
            // Force reflow so Angular re-applies the class and CSS animation restarts
            setTimeout(() => {
              item.updated = true;
              setTimeout(() => {
                item.updated = false;
              }, 600); // slightly longer than animation duration (0.55s)
            }, 0);
          } else {
            item.updated = false;
          }
        });

        this.startCountdown();
      },
      error: (err) => {
        console.error('Error fetching 2FA details:', err);
      }
    });
  }

  postUserWise2FA(parser?: any) {
    const data = {
      userId: this.userId,
      issuer: parser?.issuer || null,
      label: parser?.label || null,
      secret: parser?.secret || null
    };
    this.authenticatorService.postUserWise2FA(data).subscribe({
      next: (res) => {
        this.showQrCode = false;
        this._popup.successAndErrorDialog('success', '2FA details added successfully');
        this.getUserWise2FA(this.userId);
      },
      error: (err) => {
        console.error('Error fetching 2FA details:', err);
      }
    });
  }

  addQQrCode() {
    this.showQrCode = !this.showQrCode;
    this.manualQrCode = false;
    this.qrImage = false;
    this.otpUrls = false;
    this.editItem = false
  }

  manualEntry() {
    this.manualQrCode = !this.manualQrCode;
  }

  qrImageEntry() {
    this.qrImage = !this.qrImage;
  }

  OtpUrls() {
    this.otpUrls = !this.otpUrls;
  }

  selectFiles(event: any): void {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx?.drawImage(img, 0, 0, img.width, img.height);
        const imageData = ctx?.getImageData(0, 0, canvas.width, canvas.height);
        if (imageData) {
          const qrCode = jsQR(imageData.data, imageData.width, imageData.height);
          if (qrCode) {
            console.log("QR FOUND:", qrCode.data);
            this.importQR(qrCode.data);
          } else {
            alert("No QR code found in image.");
          }
        }
      };
    };
    reader.readAsDataURL(file);
    event.target.value = '';
  }
  removeDoc(index: number) {
    this.upload_files.splice(index, 1);
  }
  forManual() {
    let parser = {
      issuer: this.issueValue,
      label: this.labelValue,
      secret: this.secretValue
    };
    this.postUserWise2FA(parser);
  }

  importQR(qrData: string) {
    const parsed = parseOtpAuth(qrData);
    console.log('Parsed OTP Auth URL:', parsed);
    if (parsed) {
      this.postUserWise2FA(parsed);
    }
  }
  addOtpUrls() {
    console.log('OTP URL:', this.url);
    const parsed = parseOtpAuth(this.url);
    console.log('Parsed OTP Auth URL:', parsed);
    if (parsed) {
      this.postUserWise2FA(parsed);
    }
  }
  startCountdown() {
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.timerInterval = setInterval(() => {
      let needsRefresh = false; // ✅ single flag instead of calling inside forEach
      this.qrCode.forEach((item: any) => {
        if (item.expiresIn > 0) {
          item.expiresIn--;
          item.offset = item.circumference * (1 - item.expiresIn / this.TOTP_DURATION);
        } else {
          needsRefresh = true; // ✅ mark once, don't call API per item
        }
      });
      if (needsRefresh) {
        this.getUserWise2FA(this.userId); // ✅ called exactly once
      }
    }, 1000);
  }
  edit(){
    this.editItem = !this.editItem;
    this.showQrCode = !this.editItem;
    this.manualQrCode = false;
    this.qrImage = false;
    this.otpUrls = false;
    this.activeUserDropdownIndex = null; // close any open row dropdown when toggling edit mode
  }
  deleteQr(authenticatorId: any){
    this.authenticatorService.remove(authenticatorId).subscribe({
      next: (res) => {
        this.showQrCode = false;
        this._popup.successAndErrorDialog('success', '2FA details Deleted successfully');
        this.getUserWise2FA(this.userId);
      },
      error: (err) => {
        console.error('Error fetching 2FA details:', err);
      }
    });
  }
  copyCode(code: string) {
    navigator.clipboard.writeText(code).then(() => {
    }).catch(err => {
      console.error('Copy failed', err);
    });
  }
  public refresh() {
    if (this.userId) {
      this.showQrCode = true;
      this.editItem = false
      this.getUserWise2FA(this.userId);
    }
  }
  copyEntireDiv(code: string, index: number) {
    navigator.clipboard.writeText(code)
      .then(() => {
        this.copiedIndex = index;
        setTimeout(() => {
          this.copiedIndex = null;
        }, 1500);
      })
      .catch(err => console.error('Copy failed', err));
  }

  // toggleUserDropdown(item: any, i: number) {
  //   if (this.activeUserDropdownIndex === i) {
  //     this.activeUserDropdownIndex = null;
  //     return;
  //   }
  //   this.activeUserDropdownIndex = i;
  //   // Preload this item's already-selected marketing managers, if your API returns them
  //   // e.g. item.marketingManagerIds
  //   const preselected = item?.marketingManagerIds ?? [];
  //   this.selctedMarketingManagerArray.set(preselected);
  //   this.marketingMangerMultiSelectControl.setValue(preselected, { emitEvent: false });
  //   this.marketingMangerCompanySearchCtrl.setValue('', { emitEvent: false });
  // }

  toggleUserDropdown(item: any, i: number) {
    if (this.activeUserDropdownIndex === i) {
      this.activeUserDropdownIndex = null;
      return;
    }
    this.activeUserDropdownIndex = i;
    
    // Get the allUsers array from the item
    const preselected = item?.allUsers ?? [];
    console.log('Preselected user IDs:', preselected);
    
    // Set the selected values
    this.selctedMarketingManagerArray.set(preselected);
    console.log('Selected Marketing Manager Array:', this.selctedMarketingManagerArray());
    this.marketingMangerMultiSelectControl.setValue(preselected, { emitEvent: false });
    this.marketingMangerCompanySearchCtrl.setValue('', { emitEvent: false });
    
    // Also update the map with user names for display
    // You might need to fetch user details or use existing data
    this.updateSelectedUsersMap(preselected);
    this.loadInitialData();
  }

  private updateSelectedUsersMap(userIds: string[]) {
    // If you already have user data in your marketingManagerState
    const selectedUsers = this.marketingManagerState.data?.filter(
      (user) => userIds.includes(user.id)
    );
    
    selectedUsers?.forEach((user) => {
      if (user?.id) {
        this.selectedMarketingMangerMap.set(user.id, user.name);
      }
    });
  }

  cancelUserDropdown() {
    this.activeUserDropdownIndex = null;
  }
  updateMarketingManager(item: any, i: number) {
    const selectedIds = this.selctedMarketingManagerArray();
    const payload = {
      userIds: selectedIds,
    }
    this.authenticatorService.updateUsers(item.id, payload).subscribe({
      next: (response: any) => {
        this._popup.successAndErrorDialog('success', 'User details updated successfully'); 
        if (response?.data?.userIds) {
          const qrItem = this.qrCode.find((q: any) => q.id === item.id);
          if (qrItem) {
            qrItem.allUsers = response.data.userIds;            
            this.selctedMarketingManagerArray.set(response.data.userIds);
            this.marketingMangerMultiSelectControl.setValue(response.data.userIds, { emitEvent: false });
          }
        }        
        this.loadInitialData();        
        this.activeUserDropdownIndex = null;
      },
      error: (err: any) => {
        console.error('Error updating:', err);
      }
    });
  }

  onMarketingManagerChange(value: any, updateStorage: boolean = true) {
    let label: string[] = [];
    let ids = Array.isArray(value) ? value : [value];
    if (ids.includes('All')) {
      if (this.marketingMangerMultiSelectControl) {
        this.marketingMangerMultiSelectControl.setValue([], {
          emitEvent: false,
        });
      }
      this.selctedMarketingManagerArray.set([]);
      label = [];
    } else {
      ids = ids.filter((v) => v !== 'All');

      this.selctedMarketingManagerArray.set(ids);

      // find matches in current view
      const selectedMarketingMangers = this.marketingManagerState.data?.filter(
        (a) => ids.includes(a?.id),
      );

      // update cache from what we have in current data
      selectedMarketingMangers?.forEach((u) => {
        if (u?.id) {
          this.selectedMarketingMangerMap.set(u.id, u.name);
        }
      });

      // Build label from cache (full history)
      label = ids.map((id) => this.selectedMarketingMangerMap.get(id) ?? '');
    }

    const joinedValue = ids.includes('All') ? undefined : ids.join(',');
    const joinedLabel = label.join(', ');

  }

private getAllMarketManagers(): void {
    fetchPaginatedData({
      state: this.marketingManagerState,
      limit: this.limit,
      fetchFn: () => this.fetchMarketManagers(),
    });
  }
  
  private fetchMarketManagers() {
    return this.agentService
      .agentMarketing(
        '',
        this.marketingManagerState.skip,
        this.limit,
        this.marketingManagerState.searchTerm,
        '',
        this.selctedMarketingManagerArray().join(','), // This sends the selected IDs to the API
      )
      .pipe(
        map((res: any) => {
          const mappedData =
            res?.data?.data?.map((v: any) => ({
              id: v?.id,
              name: `${v?.userDetails?.firstName} ${v?.userDetails?.lastName}`,
            })) ?? [];
          res.data.data = mappedData;
          return res;
        }),
      );
  }

  private handleMarketManagersResponse(response: any): void {
    handlePaginatedResponse(this.marketingManagerState, response, this.limit);
  }
  private loadInitialData() {
    forkJoin({
      search_by_marketing_manager: this.fetchMarketManagers(),
    }).subscribe({
      next: ({
        search_by_marketing_manager,
      }) => {
        this.handleMarketManagersResponse(search_by_marketing_manager);
      },
      error: (error) => {
        console.error('Error loading data:', error);
        // this.setLoadingState(false);
      },
    });
  }
 onMarketingManagerOpenedChange(opened: boolean, selectMarketingManager: MatSelect): void {
      if (this.marketingManagerState.searchTerm) {
        this.marketingMangerCompanySearchCtrl.setValue(
          this.marketingManagerState.searchTerm,
        );
        return;
      }
      this.isMarketingManagerOpen = opened;
      if (opened) {
        setTimeout(
          () =>
            this.registerPanelScrollEvent(
              selectMarketingManager,
              'marketing_managers',
            ),
          100,
        );
      }
}

  registerPanelScrollEvent(
    select: MatSelect,
    type:'marketing_managers'
  ) {
    const panel = select?.panel?.nativeElement;
    if (!panel) return;
    panel.addEventListener('scroll', (event: any) => {
      if (
        this.hasScrolledToBottom(event.target) &&
        !this.isLoadingMoreMap.get(type)
      ) {
        this.isLoadingMoreMap.set(type, true);
        if (type === 'marketing_managers') this.getAllMarketManagers();  
        setTimeout(() => this.isLoadingMoreMap.set(type, false), 1000);
      }
    });
  }
  private hasScrolledToBottom(target: any): boolean {
    return (
      Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <
      this.PIXEL_TOLERANCE
    );
  }

}